let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Kgp2")).then(() => parcelRequire('hOQud'));